module.exports = __webpack_public_path__ + "img/banner_2.841a03d1.jpg";